import { CodedProperty, NamedProperty } from "sprint-common-web";

import { AncillaryCatalogueEntry } from "../context/AncillaryCatalogueEntry";
import { VersionDetails } from "./useAncillaryAssetsListFilters";

export const useSingleAncillaryDetails = () => {
    const getVersionDetails = (ancillary?: AncillaryCatalogueEntry): VersionDetails => {
        const versionTypes = ancillary?.version.type ? [ancillary?.version.type] : [];
        const distributors = ancillary?.version.distributor ? [ancillary?.version.distributor] : [];
        const airlines = getAirlines(ancillary?.version?.airlines).sort(sortByName);

        return { versionTypes, distributors, airlines };
    };

    return {
        getVersionDetails
    };
};

const getAirlines = (ancillaryAirlines?: CodedProperty[]): NamedProperty[] => {
    return ancillaryAirlines?.map((airline: CodedProperty): NamedProperty => airline) || [];
};

const sortByName = (a: { name: string }, b: { name: string }) => (a.name >= b.name ? 1 : -1);
